import mixpanel from 'mixpanel-browser'

const mixpanelTrack = (where: string, title: string, params?: object): void => {
  try {
    mixpanel.track(`Ação em ${where}: ${title}`, params)
  } catch (error) {
    // A maioria dos erros ocorre devido à possível falta de inicialização do Mixpanel, geralmente nos providers!
    console.error('Falha ao enviar evento do Mixpanel:', error)
  }
}

export default mixpanelTrack
